@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title">
    <div class="cards-grid stagger">
      @for (service of s.items; track service.title) {
        <app-feature-card
          [icon]="service.icon"
          [title]="service.title"
          [description]="service.description"
        />
      }
    </div>
    <div class="services-cta">
      <app-cta-button
        [label]="s.cta.label"
        variant="primary"
        [fragment]="s.cta.fragment"
      />
    </div>
  </app-section-wrapper>
}
